import { render } from "./NotFound.vue?vue&type=template&id=f9cbb0b2&scoped=true"
const script = {}

import "./NotFound.vue?vue&type=style&index=0&id=f9cbb0b2&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-f9cbb0b2"

export default script